import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class RouterService {

  public name: string;
  public route: string;


  public onUpdate: Subject<string> = new Subject<string>();

  constructor(private router: Router) {
    this.name = "Home"
    this.route = this.router.url
  }

  updateRoute() {
    const routeSplit = this.router.url.split("/")

    this.name = routeSplit[-1]
    this.route = this.router.url

    this.onUpdate.next(this.route)
  }

  navigate(commands: any[]) {
    this.router.navigate(commands)
  }
}
